 export class ShowManagementSectorsUseCase{
  constructor(sectorRepository,managementRepository) {
    this.sectorRepository = sectorRepository
    this.managementRepository = managementRepository
  }
  async execute({page, limit}){
    const sectors= await this.sectorRepository.showManagementSectors({page, limit})
    return sectors

  }
}

